module.exports = __webpack_public_path__ + "static/img/img-nofound.1776169966151.png";